var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHero6 = function SvgHero6(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78.5 65",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_6_svg__radial-gradient",
    cx: 19.8681,
    cy: -3.5165,
    r: 70.2318,
    gradientTransform: "translate(2.5 1.5) scale(0.9359 0.9538)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32db9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13c4b4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_6_svg__radial-gradient-2",
    cx: -17.3658,
    cy: 72.4954,
    r: 247.6768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    stopColor: "#a0f576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8301,
    stopColor: "#5ef9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45fbca"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_6_svg__radial-gradient-3",
    cx: 106.2426,
    cy: 115.7302,
    r: 164.0688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e899"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_6_svg__radial-gradient-4",
    cx: 46.9319,
    cy: 68.7543,
    r: 97.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00abbe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hero_6_svg__radial-gradient-5",
    cx: 52.8918,
    cy: 73.956,
    r: 86.4765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b5be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5826,
    stopColor: "#2ad5a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43e89a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "hero_6_svg__hero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_6_svg__middle-tiny"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hero_6_svg__bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,31.0692q-1.8718,12.8769-3.7436,25.7539L58.6538,63.5,2.5,45.3769,26.8333,1.5H57.7179Q66.609,16.2846,75.5,31.0692Z",
    style: {
      fill: "url(#hero_6_svg__radial-gradient)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_6_svg__shapes-shard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59,0H26L0,46l6-3L58,2Z",
    style: {
      fill: "url(#hero_6_svg__radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,0,78.5,30.5,76,32,7,46H0Z",
    style: {
      fill: "url(#hero_6_svg__radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,65l14.2327-6.3854L71,57,10,47,0,46Z",
    style: {
      fill: "url(#hero_6_svg__radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5,30.5,0,46,74.2327,58.6146,74.5,58.5Q76.5,44.5,78.5,30.5Z",
    style: {
      fill: "url(#hero_6_svg__radial-gradient-5)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hero_6_svg__highlights-5",
    "data-name": "highlights",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,43,27,25,4,44l46-8L0,46,20,11Z",
    style: {
      fill: "#f2f2f2"
    }
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHero6);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hero_6.b4886c1be049810e07ab4a731edd9de0.svg";